export default {
  addCourseRole: () => `/employee-role-courses`,
  deleteCourseRole: courseId => `/employee-role-courses/${courseId}`,
  getRolesForCourse: courseId => `/employee-role-courses/course/${courseId}`,
};
